var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"loading":_vm.loading,"type":"text"},on:{"click":_vm.toDownload}},[_vm._v(" 导出 ")])}
var staticRenderFns = []

export { render, staticRenderFns }